"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Types = exports.OTHER_NOTIF_LABEL = exports.MoveTypes = exports.MoveColorSchema = exports.DEFAULT_TIMER = exports.ColorSchema = void 0;
var ColorSchema = {
  info: {
    iconName: 'InfoOutlinedIcon',
    textColor: 'blue',
    borderColor: 'blueDark',
    backgroundColor: 'blueLight'
  },
  error: {
    iconName: 'InfoOutlinedIcon',
    textColor: 'primaryDark',
    borderColor: 'primary',
    backgroundColor: 'redLight'
  },
  newError: {
    iconName: 'InfoOutlinedIcon',
    iconColor: 'primaryDark',
    textColor: 'neutral',
    borderColor: 'primary',
    backgroundColor: 'redLight'
  },
  success: {
    iconName: 'CheckIcon',
    textColor: 'tertiaryDark',
    borderColor: 'tertiaryDark',
    backgroundColor: 'greenLight'
  },
  warning: {
    iconName: 'NotificationsIcon',
    textColor: 'neutral',
    borderColor: 'yellow',
    backgroundColor: 'yellowLight'
  },
  newWarning: {
    iconName: 'NotificationsIcon',
    iconColor: 'yellow',
    textColor: 'neutral',
    borderColor: 'yellow',
    backgroundColor: 'yellowLight'
  },
  fomoWarning: {
    iconName: 'Sort',
    iconColor: 'yellow',
    textColor: 'yellow',
    borderColor: 'yellow',
    backgroundColor: 'yellowLight'
  },
  warningLight: {
    iconName: 'NotificationUnfilled',
    iconColor: 'yellowLight',
    textColor: 'charcoalGrey',
    borderColor: 'yellow',
    backgroundColor: 'yellowLight'
  },
  newInfo: {
    iconName: 'Info',
    iconColor: 'blue',
    textColor: 'neutral',
    borderColor: 'blue',
    backgroundColor: 'blueLight',
    textType: 'textSmall'
  },
  seats: {
    iconName: 'StarInvertedIcon',
    iconColor: 'green',
    textColor: 'neutral',
    backgroundColor: 'neutral'
  },
  newNotif: {
    iconName: 'InfoOutlinedIcon',
    textColor: 'default',
    borderColor: 'greyDarker',
    backgroundColor: 'greyDarker'
  }
};
exports.ColorSchema = ColorSchema;
var Types = ['info', 'error', 'warning', 'success', 'newWarning', 'newInfo', 'newNotif', 'warningLight'];
exports.Types = Types;
var OTHER_NOTIF_LABEL = 'Other Notifications ({0})';
exports.OTHER_NOTIF_LABEL = OTHER_NOTIF_LABEL;
var DEFAULT_TIMER = 4800;
exports.DEFAULT_TIMER = DEFAULT_TIMER;
var MoveColorSchema = {
  error: {
    iconName: 'InfoOutlinedIcon',
    textColor: 'primaryRed',
    borderColor: 'primaryRed',
    backgroundColor: 'redLight'
  }
};
exports.MoveColorSchema = MoveColorSchema;
var MoveTypes = ['error'];
exports.MoveTypes = MoveTypes;